import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider as StyletronProvider } from 'styletron-react';
import { Client as Styletron } from 'styletron-engine-atomic';

// Initialize Styletron (required for Base Web)
const engine = new Styletron();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StyletronProvider value={engine}>
      <App />
    </StyletronProvider>
  </React.StrictMode>
);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // Register the service worker
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('Service Worker registered with scope:', registration.scope);
      
      // iOS PWA specific code
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
      
      // Check if this is iOS and not already in standalone mode
      if (isIOS && !isInStandaloneMode) {
        // Add a custom event listener to detect when the user adds to home screen
        window.addEventListener('beforeinstallprompt', (e) => {
          // For iOS, we need to manually show installation instructions
          console.log('PWA install prompt detected on iOS');
          // You could show a custom installation prompt here
        });
        
        // Log that we're on iOS for debugging
        console.log('Running on iOS - PWA requires manual installation via Share button');
      }
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  });
}
